<style src="css/selectTime.css" scoped></style>
<template>
  <div style="padding-top: 0.98rem; padding-bottom: 0.98rem">
    <topbar text="预约咨询"></topbar>
    <div class="mainBox">
      <div class="titleBox">
        咨询方式
        <div class="one"></div>
      </div>
      <div class="consultingListBox">
        <div class="consultingList" v-if="doctorDetail.chatDoctorServe">
          <div
            class="consultingItem"
            :class="{
              active: doctorDetail.chatDoctorServe.video,
              active2: serveType === 2,
            }"
            @click="select(doctorDetail.chatDoctorServe.video, 2, '视频咨询')"
          >
            <div class="trueIcon" v-if="serveType === 2"></div>
            <div class="selectBox">视频咨询</div>
          </div>
          <div
            class="consultingItem"
            :class="{
              active: doctorDetail.chatDoctorServe.telephone,
              active2: serveType === 1,
            }"
            @click="
              select(doctorDetail.chatDoctorServe.telephone, 1, '语音咨询')
            "
          >
            <div class="trueIcon" v-if="serveType === 1"></div>
            <div class="selectBox">语音咨询</div>
          </div>
          <div
            class="consultingItem"
            :class="{
              active: doctorDetail.chatDoctorServe.imageText,
              active2: serveType === 0,
            }"
            @click="
              select(doctorDetail.chatDoctorServe.imageText, 0, '图文咨询')
            "
          >
            <div class="trueIcon" v-if="serveType === 0"></div>
            <div class="selectBox">图文咨询</div>
          </div>
          <div
            class="consultingItem"
            :class="{
              active: doctorDetail.chatDoctorServe.offline,
              active2: serveType === 3,
            }"
            @click="xxStatus = true"
          >
            <div class="trueIcon" v-if="serveType === 3"></div>
            <div class="selectBox">线下咨询</div>
          </div>
        </div>
        <div
          style="margin-top: 0.2rem; margin-left: 0.24rem; font-size: 0.24rem"
          v-if="
            doctorDetail.chatDoctorServe != undefined &&
            doctorDetail.chatDoctorServe.offline
          "
        >
          线下地址：{{ doctorDetail.chatDoctorServe.remark }}
        </div>
      </div>

      <div class="titleBox">
        可约时间<span style="font-size: 0.26rem"
          >（每次咨询为50分钟,下滑日期查看更多）</span
        >
        <div class="two"></div>
      </div>
      <div class="timeBox" v-if="doctorDetail.chatDoctorSchedules">
        <div class="item" v-for="item in doctorDetail.chatDoctorSchedules">
          <div
            class="timeItem"
            :class="{ active: JSON.parse(item.dateValue).length > 0 }"
          >
            {{ item.scheduleDate | week }}
            <span id="aa">{{ item.scheduleDate | MM }}</span>
          </div>
          <div class="itemBlock active2" v-if="item.type == 1">已约满</div>
          <div
            class="itemBlock"
            :class="{ active: getDate(item.scheduleDate) + v === bespeakDate , active3 : getValue(v)}"
            @click="selectDateTime(item.scheduleDate, v)"
            v-for="v in JSON.parse(item.dateValue)"
          >
            {{ v }}
          </div>
        </div>
      </div>
    </div>
    <div class="bottomBox">
      <div class="bottomLeft">
        <!--                <div class="dateIcon"></div>-->
        <div class="infoBox">
          <div class="dateTime">{{ bespeakDate }}</div>
          <div class="serve">{{ name }}</div>
        </div>
      </div>
      <div class="bottomRight" @click="showM()">下一步</div>
    </div>

    <div class="maskBox" v-if="maskStatus">
      <div class="mask">
        <div class="maskTop">
          <div class="maskTitle">
            您确定要预约<span style="color: #408bfb">{{ bespeakDate }}</span
            >的{{
              name
            }}吗？预约成功后请于30分钟内完成个人信息的填写，并签署心理咨询服务协议，逾期将视为放弃本次预约。预约成功后，请准时进行咨询；若无法准时进行咨询，请提前取消预约。
          </div>
        </div>
        <div class="btnBox">
          <div class="btn" @click="maskStatus = false">取消</div>
          <div class="btn active" @click="userDoBespeak">确定</div>
        </div>
      </div>
    </div>

    <div class="maskBox" v-if="xxStatus">
      <div class="mask">
        <div class="maskTop">
          <div class="maskTitle">
            咨询师线下咨询地址为：<span style="color: #408bfb">{{
              doctorDetail.chatDoctorServe.remark
            }}</span
            >，请确认预约无误~
          </div>
        </div>
        <div class="btnBox">
          <div class="btn" @click="xxStatus = false">取消</div>
          <div
            class="btn active"
            @click="select(doctorDetail.chatDoctorServe.offline, 3, '线下咨询')"
          >
            确定
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import moment from "moment/moment";

import { Swiper, Slide } from "vue-swiper-component";
import { serialize } from "utils/index";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      doctorDetail: {},
      serveType: "",
      name: "",
      bespeakDate: "",
      maskStatus: false,
      xxStatus: false,
    };
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },

    MM(value) {
      let transTime = moment(value).format("MM-DD");
      return transTime;
    },
    week(value) {
      let time = moment(value).format("dddd");
      let obj = {
        Monday: "周一",
        Tuesday: "周二",
        Wednesday: "周三",
        Thursday: "周四",
        Friday: "周五",
        Saturday: "周六",
        Sunday: "周日",
      };
      return obj[time];
    },
  },
  computed: {},
  methods: {
    showM() {
      if (!this.name) {
        alert("请您选择咨询方式");
        return;
      } else if (!this.bespeakDate) {
        alert("请您选择时间");
        return;
      }
      this.maskStatus = true;
    },
    selectDateTime(i, v) {
      if (v.indexOf("已") == -1) {
        this.bespeakDate = this.getDate(i) + v;
      }
    },
    getValue(v){
       if (v.indexOf("已") == -1) {
         return false
      }else{
        return true
      }
    },
    getDate(value) {
      let transTime = moment(value).format("YYYY-MM-DD") + " ";
      return transTime;
    },
    select(a, b, c) {
      if (a) {
        this.serveType = b;
        this.name = c;
      } else {
        alert(`该咨询方式尚未开通~`);
      }
      this.xxStatus = false;
    },
    async getDoctorDetail(id) {
      let obj = {};
      obj.doctorId = id;
      obj.userId = localStorage.getItem("userId");
      let data = await getSources(
        "/bear-scale/api/chatDoctor/getDoctorScheduleToBespeak.json",
        obj
      );
      if (data.status === 0) {
        this.doctorDetail = data.doctorSchedule;
        if (data.doctorSchedule.chatDoctorServe.video == 1) {
          this.serveType = 2;
          this.name = '视频咨询';
        } else if (data.doctorSchedule.chatDoctorServe.telephone == 1) {
          this.serveType = 1;
          this.name = '语音咨询';
        } else if (data.doctorSchedule.chatDoctorServe.imageText == 1) {
          this.serveType = 0;
          this.name = '图文咨询';
        } else if (data.doctorSchedule.chatDoctorServe.offline == 1) {
          this.serveType = 3;
          this.name = '线下咨询';
        }
      } else {
        alert(data.msg);
      }
    },
    async userDoBespeak(id) {
      let obj = {};
      obj.userId = localStorage.getItem("userId");
      obj.doctorId = this.$route.query.doctorId;
      obj.serveType = this.serveType;
      obj.bespeakTimes = 1;
      obj.bespeakDate = this.bespeakDate + ":00";
      let data = await getSources(
        "/bear-scale/api/scaleUserBespeak/userDoBespeak.json",
        obj
      );
      if (data.status === 0) {
        this.$router.push(`/serveInfo?bespeakId=${data.bespeakId}`);
      } else {
        alert(data.msg);
      }
    },
  },
  destroyed() {},
  mounted() {
    this.getDoctorDetail(this.$route.query.doctorId);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/selectTime.vue?93f938cc